// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeIdentityUnlinkBody = {
  provider: "apple" | "google";
};

export type typeIdentityUnlinkOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { provider: "apple" | "google"; isLinked: boolean };
};

export type typeIdentityUnlinkOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeIdentityUnlinkOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeIdentityUnlinkOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaIdentityUnlinkBody = {
  type: "object",
  properties: { provider: { type: "string", enum: ["apple", "google"] } },
  required: ["provider"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createIdentityUnlink(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaIdentityUnlinkBody);
  }

  return async function postIdentityUnlink(
    payload: typeIdentityUnlinkBody,
  ): Promise<typeIdentityUnlinkOutput200 | typeIdentityUnlinkOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postIdentityUnlink" failed before calling the network. #8d4aea287e51`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#8d4aea287e51" },
        },
        data: null,
      } as typeIdentityUnlinkOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/identity/unlink`,
      httpMethod: "POST",
      options,
    })) as typeIdentityUnlinkOutput200 | typeIdentityUnlinkOutput400;
  };
}
